module.exports = __webpack_public_path__ + "img/111.8.f722404b.png";